import { frontendURL } from '../../../helper/URLHelper';
import Index from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ovva'),
    name: 'ovva_panel_index',
    meta: {
      // Панель открыта и оператору: ему нужны материалы, чекап и отчёты.
      // Административные вкладки внутри (настройки AI, бренды, интеграции,
      // подтверждения) прячутся по роли — см. embed.ejs, applyRoleScope().
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: Index,
  },
];
